import React from 'react';
import { Row, Col } from 'react-styled-flexboxgrid';
import PropTypes from 'prop-types';
import { Line } from '@vds/lines';
import { Title, Body } from '@vds/typography';

import { Margin } from '../../../common/styles';
import { isMobile } from '../../../common/Helpers/useragent';
import { parseDate } from '../../../common/Helpers/dates';
import { formatCurrency, formatDay, formatMtnWithDecimals } from '../NextBillsUtils';

const NBSPendingDiscount = (props) => {
  const nbsVo = props.data || {};

  const nextMonthChargeDateRange =
    nbsVo &&
    nbsVo.monthlyTotalsInfo &&
    nbsVo.monthlyTotalsInfo.nextMonthChargeDateRange &&
    nbsVo.monthlyTotalsInfo.nextMonthChargeDateRange.split('-')[1];

  const nextBillDate = parseDate(nextMonthChargeDateRange);

  const { pendingChargesAndDiscounts = '', pendingChargesAndDiscounts: { totalPendingCharges = '', mtnLevelPendingInfo = [] } = {} } = nbsVo || {};

  const renderMTN = (indicator, mtn, npanxx) => {
    let mtnValue = '';

    if (indicator && indicator === 'Y') {
      mtnValue = `${formatMtnWithDecimals(mtn)} (new)`;
    } else {
      mtnValue = formatMtnWithDecimals(mtn);
    }
    if (npanxx !== undefined && indicator && indicator === 'Y') {
      mtnValue = npanxx && npanxx !== '' ? formatMtnWithDecimals(npanxx) : '';
    }
    return mtnValue;
  };

  return (
    <div data-testid="NBSPendingDiscount">
      {pendingChargesAndDiscounts && pendingChargesAndDiscounts.mtnLevelPendingInfo && (
        <div>
          <Margin top="20px">
            <Line type="primary" />
            <Margin top="8px">
              <Title size="medium" primitive="h3" bold>
                {props.PendingCharges1}
                {nextBillDate.month} {formatDay(nextBillDate.day)}
                {' bill'}
              </Title>
            </Margin>
          </Margin>

          {mtnLevelPendingInfo &&
            mtnLevelPendingInfo.map((item) => (
              <>
                <Margin top="20px" bottom="20px">
                  <Row style={{ maxWidth: '100%' }}>
                    <Col xs={12} sm={12} md={12} lg={12}>
                      <Body size={isMobile() ? 'medium' : 'large'} primitive="p" bold>
                        {item.mtnNickName}
                      </Body>
                      <Body size={isMobile() ? 'medium' : 'large'} primitive="p">
                        {renderMTN(item.pendingActivationIndicator, item.mtn, item.npanxx)}
                        {item.pendingActivationIndicator && item.pendingActivationIndicator === 'Y' ? (
                          <>
                            <br />
                            Pending Order
                          </>
                        ) : (
                          ''
                        )}
                      </Body>
                    </Col>
                  </Row>

                  <Margin top="8px">
                    <Row style={{ maxWidth: '100%' }}>
                      {item.pendingDetails.map((line) => (
                        <>
                          <Col xs={8} sm={8} md={8} lg={8}>
                            <Body size={isMobile() ? 'medium' : 'large'} primitive="p">
                              {line.pendingDescription}
                            </Body>
                          </Col>
                          <Col xs={4} sm={4} md={4} lg={4} style={{ textAlign: 'right' }}>
                            <Body size={isMobile() ? 'medium' : 'large'} primitive="p">
                              {formatCurrency(line.pendingAmount)}
                            </Body>
                          </Col>
                        </>
                      ))}
                    </Row>
                  </Margin>
                </Margin>
                <Line type="secondary" />
              </>
            ))}
          {totalPendingCharges && totalPendingCharges !== undefined && totalPendingCharges !== 0 && (
            <>
              <Margin top="20px">
                <Row style={{ maxWidth: '100%' }}>
                  <Col xs={9} sm={9} md={9} lg={9}>
                    <Body size="large" primitive="p" bold>
                      {props.totalPendingChargesText}
                    </Body>
                  </Col>
                  <Col xs={3} sm={3} md={3} lg={3} style={{ textAlign: 'right' }}>
                    <Body size="large" primitive="p" bold>
                      ${totalPendingCharges}
                    </Body>
                  </Col>
                </Row>
              </Margin>
            </>
          )}
          {pendingChargesAndDiscounts?.displayPendingEquipementFlag &&
            (pendingChargesAndDiscounts.displayPendingEquipementFlag.toLowerCase() === 'y' ||
              pendingChargesAndDiscounts.displayPendingEquipementFlag.toLowerCase() === 'true') && (
              <div style={{ marginTop: '2vh' }}>
                <Body size={isMobile() ? 'medium' : 'large'} viewport="desktop" primitive="p" color="#747676">
                  {props.displayPendingEquipementFlagText}
                </Body>
              </div>
            )}
          {pendingChargesAndDiscounts?.displayPendingTradeInFlag &&
            (pendingChargesAndDiscounts.displayPendingTradeInFlag.toLowerCase() === 'y' ||
              pendingChargesAndDiscounts.displayPendingTradeInFlag.toLowerCase() === 'true') && (
              <div style={{ marginTop: '2vh' }}>
                <Body size={isMobile() ? 'medium' : 'large'} viewport="desktop" primitive="p" color="#747676">
                  {props.displayPendingTradeInFlagText}
                </Body>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

NBSPendingDiscount.defaultProps = {
  PendingCharges1: 'Charges and credits will be applied after your ',
  totalPendingChargesText: 'Total pending charges and credits to be applied',
  displayPendingEquipementFlagText: 'Pending charges and credits will be applied when your order ships, based on availability.',
  displayPendingTradeInFlagText: '**Credit to be applied once your eligible trade-in device has been received and its condition confirmed.',
};

NBSPendingDiscount.propTypes = {
  data: PropTypes.object,
  PendingCharges1: PropTypes.string,
  totalPendingChargesText: PropTypes.string,
  displayPendingEquipementFlagText: PropTypes.string,
  displayPendingTradeInFlagText: PropTypes.string,
};

export default React.memo(NBSPendingDiscount);
